import Icon from '../components/Icon.vue'

Icon.register({
  'minus-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM124 296h264c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12h-264c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/minus-circle.js
// module id = 1571
// module chunks = 0